import React, { useState } from "react";
import { Box, Dialog, DialogContent } from "@mui/material";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported"; // Importando um ícone do MUI

const ImageMessage = ({ message }) => {
  const [imageError, setImageError] = useState(false); // Estado para rastrear erros de imagem
  const [open, setOpen] = useState(false); // Controle do modal de visualização

  const raw = message?.image || "";
  const isAbsolute =
    typeof raw === "string" &&
    (raw.startsWith("http://") ||
      raw.startsWith("https://") ||
      raw.startsWith("blob:") ||
      raw.startsWith("data:"));

  const imageUrl = isAbsolute ? raw : `https://xvision.xpro.me${raw}`;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {imageError ? (
          <ImageNotSupportedIcon sx={{ fontSize: 60, color: "gray" }} />
        ) : (
          <Box
            component="img"
            src={imageUrl}
            alt="Imagem enviada"
            sx={{
              maxWidth: 220,
              maxHeight: 220,
              borderRadius: 1,
              cursor: "pointer",
              objectFit: "cover",
            }}
            onClick={() => setOpen(true)}
            onError={() => setImageError(true)}
          />
        )}
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogContent
          sx={{
            p: 0,
            backgroundColor: "black",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {!imageError && (
            <Box
              component="img"
              src={imageUrl}
              alt="Imagem enviada"
              sx={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                objectFit: "contain",
              }}
              onError={() => setImageError(true)}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageMessage;
